/* @flow */

const tocarSino = () => {
    const audio = new global.Audio('/audio/notificacao-amp.mp3');
    audio.play().catch(() => null);
};

export default tocarSino;
